<template>
  <div class="finance-statements key-indicator">
    <MoreTitle title="主要指标" @click="goPage">
      <template v-slot:left>
        {{ $t('主要指标') }}<span class="laste-report-icon">{{ lasteReportDate }}</span>
      </template>
    </MoreTitle>
    <div class="edge-padding">
      <RkSwitch :options="switchOptions" v-model="activeSwitch" spread class="rk-switch--indicator" />
      <div class="position-wrap">
        <RkSelect :options="selectOptions" v-model="activeSelect" class="rk-select--indicator" />
        <FinanceIndicatorEchart :data="echartData" :name="activeSwitchItem.label" />
      </div>
      <RkTable :data="echartData" :showFooter="false" :header-split-line="false">
        <RkTableColumn prop="reportDate" label="报告期" align="left"></RkTableColumn>
        <RkTableColumn prop="barValue" :label="activeSwitchItem.label">
          <template #header>{{ activeSwitchItem.label }}</template>
          <template slot-scope="{ row }">
            {{
              activeSwitchItem.percentage
                ? $digitjs(row.barValue).unit('%').rounded()
                : $digitjs(row.barValue).convert()
            }}
          </template>
        </RkTableColumn>
        <RkTableColumn prop="lineValue" label="同比上涨">
          <template slot-scope="{ row }">
            <span :style="{ color: $digitjs(row.lineValue).color() }">{{
              $digitjs(row.lineValue).unit('%').rounded()
            }}</span>
          </template>
        </RkTableColumn>
      </RkTable>
    </div>
  </div>
</template>

<script>
import RkSwitch from '@/components/common/RkSwitch.vue'
import FinanceIndicatorEchart from './FinanceIndicatorEchart.vue'
const REPORT_TYPE_MAP = {
  F: '年报',
  Q1: '一季报',
  I: '中报',
  Q3: '三季报'
}
export default {
  components: { RkSwitch, FinanceIndicatorEchart },
  data() {
    return {
      indicatorData: [],
      switchOptions: Object.freeze([
        [
          {
            value: 'netIncomeRatio',
            label: '净利率',
            class: '!px14py4',
            percentage: true
          },
          {
            value: 'netAssetsPS',
            label: '每股净资产',
            percentage: false
          },
          {
            value: 'eps',
            label: '每股收益',
            percentage: false
          },
          {
            value: 'returnOnEquity',
            label: '净资产收益率',
            percentage: true
          }
        ],
        [
          {
            value: 'grossProfitMargin',
            label: '毛利率',
            percentage: true
          },
          {
            value: 'operatingCashFlowPS',
            label: '每股现金流',
            percentage: false
          },
          {
            value: 'debtAssetRatio',
            label: '资产负债率',
            percentage: true
          },
          {
            value: 'returnOnTotalAssets',
            label: '总资产收益率',
            percentage: true
          }
        ]
      ]),
      selectOptions: Object.freeze([
        { label: '全部', value: 'F/Q1/I/Q3' },
        { label: '年报', value: 'F' }
      ]),

      activeSwitch: 'netIncomeRatio',
      activeSelect: 'F/Q1/I/Q3'
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    activeSwitchItem() {
      return this.switchOptions.flat().find(({ value }) => value === this.activeSwitch)
    },
    echartData() {
      const activeArr = this.activeSelect.split('/')
      const data = this.indicatorData.filter(({ reportType }) => activeArr.includes(reportType)).slice(0, 5)

      return data.map((item) => {
        const { reportDate, reportType } = item

        const xAxis = `${reportDate?.slice(0, 4)}\n${this.$t(REPORT_TYPE_MAP[reportType])}`
        const barValue = item[this.activeSwitch]
        const lineValue = item[this.activeSwitch + 'YoY']

        return { reportDate, xAxis, barValue, lineValue }
      })
    },
    lasteReportDate() {
      const { reportDate, reportType } = this.indicatorData[0] ?? {}
      return reportDate && reportType
        ? `(${this.$t('$x年', {
            x: reportDate?.slice(0, 4)
          })}${this.$t(REPORT_TYPE_MAP[reportType])})`
        : ''
    }
  },
  watch: {
    activeSelect() {
      this.getKeyIndicator()
    }
  },
  created() {
    this.getKeyIndicator()
  },
  methods: {
    async getKeyIndicator() {
      const res = await this.$post(this.$api.f10.hk + '/finance/key-indicator', {
        symbol: this.symbol,
        startDate: '1997-01-01'
      })
      this.indicatorData = res.data ?? []
    },
    goPage() {
      this.$router.push({
        path: '/f10/statements',
        query: {
          symbol: this.$route.query.symbol,
          type: 'indicators'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.position-wrap {
  border-bottom: 1px solid var(--split-color);
  margin-bottom: 12px;
}

.finance-statements {
  :deep(.rk-switch--spread .rk-switch-item) {
    border-radius: 50px;
    border: 1px solid var(--font-color-3);
  }
  :deep(.rk-switch--spread .rk-switch-item--active) {
    border: 1px solid var(--font-color-1) !important;
  }
  :deep(.select .curr) {
    border-radius: 50px;
  }
}
</style>
